import React, {useEffect,useRef} from 'react';
import L from 'leaflet';
import {mapCoordinates} from '../utils/propertyCoordinates';
import {addIllustratedBasemap} from '../services/illustratedBasemap';
import {propertyMapIcon} from '../utils/mapMarkerIcons';
import 'leaflet/dist/leaflet.css';
import './PropertyMapPreview.css';

export default function PropertyMapPreview({property,onExpand}) {
  const canvas=useRef(null),mapRef=useRef(null),expandRef=useRef(onExpand);
  expandRef.current=onExpand;
  const coordinates=mapCoordinates(property),lat=coordinates?.lat,lon=coordinates?.lon;
  const amount=property?.current_price ?? property?.list_price ?? property?.price;
  const listingKey=property?.listing_key;
  const isPrivate=Boolean(property?.isPrivate);
  const expand=()=>{
    const map=mapRef.current;
    if(map) expandRef.current?.({center:map.getCenter(),zoom:map.getZoom()});
  };
  useEffect(()=>{
    if(lat == null || lon == null || !canvas.current) return undefined;
    const map=L.map(canvas.current,{
      minZoom:1,maxZoom:19,scrollWheelZoom:true,doubleClickZoom:false,
      zoomAnimation:false,fadeAnimation:false,markerZoomAnimation:false
    }).setView([lat,lon],15);
    mapRef.current=map;
    addIllustratedBasemap(map);
    const open=()=>expandRef.current?.({center:map.getCenter(),zoom:map.getZoom()});
    L.marker([lat,lon],{icon:propertyMapIcon(amount,{isPrivate}),title:'Selected property'}).addTo(map).on('click',open);
    // Leaflet suppresses map clicks after dragging; its zoom buttons stop click
    // propagation. Clicking the map itself still opens the larger view.
    map.on('click',open);
    let disposed=false;
    const resize=()=>{if(!disposed)map.invalidateSize({pan:false});};
    const observer=typeof ResizeObserver==='undefined'?null:new ResizeObserver(resize);
    observer?.observe(canvas.current);
    const timer=setTimeout(resize,50);
    return()=>{disposed=true;clearTimeout(timer);observer?.disconnect();map.remove();mapRef.current=null;};
  },[lat,lon,amount,listingKey,isPrivate]);
  if(!coordinates) return null;
  return <div className="property-map-preview" role="region" aria-label="Property location preview">
    <div ref={canvas} className="property-map-preview-canvas" aria-label="Property map. Use the zoom controls, scroll, or drag to explore." />
    <button type="button" className="property-map-preview-expand" onClick={expand} aria-label="Open interactive map for this property">
      <svg width="14" height="14" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true"><path d="M7 3H3v4m10-4h4v4M3 13v4h4m10-4v4h-4" /></svg>
      Expand map
    </button>
  </div>;
}
